<template>
    <svg
        :style="{ backgroundColor }"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M28.077 25C27.118 25 26.3013 24.6597 25.627 23.979C24.9527 23.298 24.6155 22.4717 24.6155 21.5V12.5C24.6155 11.5283 24.9527 10.702 25.627 10.021C26.3013 9.34033 27.118 9 28.077 9H31.6345C32.5808 9 33.3783 9.34033 34.027 10.021C34.6757 10.702 35 11.5283 35 12.5V21.5C35 22.4717 34.6757 23.298 34.027 23.979C33.3783 24.6597 32.5808 25 31.6345 25H28.077ZM28.077 22H31.6345C31.7498 22 31.8397 21.952 31.904 21.856C31.968 21.7597 32 21.641 32 21.5V12.5C32 12.359 31.968 12.2403 31.904 12.144C31.8397 12.048 31.7498 12 31.6345 12H28.077C27.9487 12 27.8397 12.048 27.75 12.144C27.6603 12.2403 27.6155 12.359 27.6155 12.5V21.5C27.6155 21.641 27.6603 21.7597 27.75 21.856C27.8397 21.952 27.9487 22 28.077 22ZM19 35C18.2923 35 17.6622 34.7962 17.1095 34.3885C16.5572 33.9808 16.1733 33.4398 15.958 32.7655L11.131 16.55C11.0643 16.396 11.0258 16.2318 11.0155 16.0575C11.0052 15.8832 11 15.7025 11 15.5155V10.5C11 10.0743 11.1437 9.718 11.431 9.431C11.718 9.14367 12.0743 9 12.5 9C12.9257 9 13.282 9.14367 13.569 9.431C13.8563 9.718 14 10.0743 14 10.5V16L18.8845 32H33.5C33.9257 32 34.282 32.1437 34.569 32.431C34.8563 32.718 35 33.0743 35 33.5C35 33.9257 34.8563 34.282 34.569 34.569C34.282 34.8563 33.9257 35 33.5 35H19ZM17.904 41C17.4783 41 17.1218 40.8563 16.8345 40.569C16.5475 40.282 16.404 39.9257 16.404 39.5C16.404 39.0743 16.5475 38.718 16.8345 38.431C17.1218 38.1437 17.4783 38 17.904 38H33.4805C33.9062 38 34.2627 38.1437 34.55 38.431C34.837 38.718 34.9805 39.0743 34.9805 39.5C34.9805 39.9257 34.837 40.282 34.55 40.569C34.2627 40.8563 33.9062 41 33.4805 41H17.904ZM28.077 12H27.6155H32H28.077Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
